import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor() {
  }

  openChatWindow(): void {
    window.WebChatInstance?.openWindow();
  }

  closeChatWindow(): void {
    window.WebChatInstance?.closeWindow();
  }

  destroyChatSession(): void {
    window.WebChatInstance?.destroySession();
    // window.WebChatInstance.restartConversation();
  }

  destroyChatInstance(): void {
    window.WebChatInstance?.destroy();
  }
}
